// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        borderTop: "1px solid rgba(64,190,180,0.15)",
        padding: "24px 32px",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Top gradient line accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, rgba(64,190,180,0.4), rgba(255,200,80,0.2), transparent)",
        }}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          flexWrap: "wrap",
          marginBottom: "12px",
        }}
      >
        {[
          { to: "/privacy-policy", label: "Privacy Policy" },
          { to: "/terms", label: "Terms & Conditions" },
          { to: "/contact", label: "Contact Us" },
        ].map((link, idx, arr) => (
          <React.Fragment key={link.to}>
            <Link
              to={link.to}
              style={{
                color: "#40BEB4",
                textDecoration: "none",
                fontSize: "13px",
                fontWeight: 500,
                letterSpacing: "0.3px",
                opacity: 0.85,
                transition: "opacity 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = 1)}
              onMouseLeave={(e) => (e.target.style.opacity = 0.85)}
            >
              {link.label}
            </Link>
            {idx < arr.length - 1 && (
              <span style={{ color: "rgba(64,190,180,0.3)", fontSize: "13px" }}>|</span>
            )}
          </React.Fragment>
        ))}
      </div>

      <p
        style={{
          color: "rgba(255,255,255,0.25)",
          fontSize: "12px",
          margin: 0,
          letterSpacing: "0.3px",
        }}
      >
        © {new Date().getFullYear()} Advitiya Tantragyan Research and Development Labs Pvt Ltd. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
